import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { onHttpRequest, onHttpResponseResolve, onHttpResponseReject, TokenGenerator as Generator } from './interceptor';

export type TokenGenerator = Generator;
export { show } from './handler';
export { isBaseError, isCancelError } from './utils';
export * from './code';
export * from './error';

export const CancelRequestKey = 'CancelRequest';
export const CancelPrevRequestKey = 'CancelPrevRequest';

export function createAxios(config: AxiosRequestConfig, tokenGenerator: TokenGenerator): AxiosInstance {
  const http = axios.create(config);
  http.interceptors.request.use((config) => onHttpRequest(config, tokenGenerator));
  http.interceptors.response.use(onHttpResponseResolve, onHttpResponseReject);
  return http;
}
